// ** React Imports
import { useState } from "react";

// ** Third Party Components
import { t } from "i18next";

// ** Custom Components
import Block from "components/layout/Block";
import AuthPanel from "containers/Landing/components/AuthPanel";
import Text from "components/typography/Text";

// ** Styled Components
import { StyledModalAuthContentWrapper } from "./styles/ModalAuthContentWrapper.styled";
import { StyledModalAuthMainSection } from "./styles/ModalAuthMainSection.styled";

// #####################################################

const ModalAuthContent = ({ innerRef }) => {
	const [activeTab, setActiveTab] = useState("login");

	const [oAuth, setOAuth] = useState({
		provider: null,
		initiator: null,
		token: null,
		state: null,
		active: false,
		email: null,
		loading: false,
	});

	// #####################################################

	return (
		<StyledModalAuthMainSection>
			<Block flex flexWrap fullWidth>
				<StyledModalAuthContentWrapper ref={innerRef}>
					<AuthPanel
						activeTab={activeTab}
						setActiveTab={setActiveTab}
						oAuth={oAuth}
						setOAuth={setOAuth}
						isModal={true}
						additionalContent={
							<Block
								flex
								flexWrap
								fullWidth
								py={6}
								style={{
									color: "var(--dz-comp-auth-panel-text-color)",
								}}
							>
								<Text>{t("common:authModal.infoText")}</Text>
							</Block>
						}
					/>
				</StyledModalAuthContentWrapper>
			</Block>
		</StyledModalAuthMainSection>
	);
};

// #####################################################

export default ModalAuthContent;

// #####################################################
